import socketService from '@services/socketService';

/*
 * Évènements live poussés par le BO sur un thread (voir RealtimePushService/ConstListUtils.REALTIME_EVENT_TYPE côté BO).
 * Ce service cache les destinations STOMP et les noms de type d'évènement aux composants : ils ne manipulent que des
 * callbacks nommés.
 */

export const REALTIME_EVENT_TYPE = {
  MESSAGE_ADDED: 'message_added',
  MESSAGE_STATUS: 'message_status',
  MESSAGE_READ: 'message_read',
  THREAD_UPDATED: 'thread_updated',
  TYPING: 'typing',
  // Canal global /topic/threads (cf. ADR 0001 et 0003) : un abonnement permanent par employé GuestAdom, tout ce qui
  // modifie un item de la liste des conversations. Miroir de ConstListUtils.REALTIME_EVENT_TYPE côté BO.
  MESSAGE_POSTED: 'message_posted',
  THREAD_READ: 'thread_read',
  THREAD_FAVORITED: 'thread_favorited',
  THREAD_ASSIGNED: 'thread_assigned',
  THREAD_TYPE: 'thread_type',
  THREAD_ARCHIVED: 'thread_archived',
  THREAD_CREATED: 'thread_created',
};

const THREADS_TOPIC = '/topic/threads';

function threadTopic(threadId) {
  return `/topic/thread/${threadId}`;
}

export default {
  // Identifie cet onglet/session (voir socketService) : utile pour ignorer son propre indicateur de saisie.
  clientId: socketService.clientId,
  /**
   * S'abonne aux évènements d'un thread. `handlers` associe un ou plusieurs REALTIME_EVENT_TYPE à un callback
   * `(payload) => void`. Renvoie un objet `{unsubscribe()}`.
   */
  // `originClientId` est transmis en second argument du callback (et non filtré ici, contrairement au canal
  // global) : certains signaux de ce canal (message_added/message_status) doivent au contraire être traités pour
  // son propre écho, pour réconcilier le message optimiste local avec sa forme serveur -- seul l'appelant sait,
  // signal par signal, s'il doit ignorer son propre évènement (cf. ADR 0003 décision 4).
  subscribeToThread(threadId, handlers) {
    return socketService.subscribe(threadTopic(threadId), (event) => {
      const handler = handlers[event.type];
      if (handler) handler(event.payload, event.originClientId);
    });
  },
  sendTyping(threadId) {
    // Le BO connaît déjà notre clientId (en-tête envoyé à la connexion, cf. socketService) : rien à joindre ici.
    socketService.publish(`/app/thread/${threadId}/typing`, {});
  },
  /**
   * S'abonne au canal global /topic/threads (un seul abonnement permanent par employé GuestAdom, cf. ADR 0001).
   * Contrairement à subscribeToThread, `onEvent` reçoit l'enveloppe complète {type, payload, originClientId} : le
   * filtrage par type et l'écho d'auteur sont délégués à l'appelant (le store Pinia dédié), qui multiplexe vers
   * plusieurs composants consommateurs. Renvoie un objet `{unsubscribe()}`.
   */
  subscribeToThreads(onEvent) {
    return socketService.subscribe(THREADS_TOPIC, onEvent);
  },
};
